// store/modules/notification.js
import { getNotification } from '@/api/config'

const state = {
    notifications: [],
    loading: false
}

const mutations = {
    SET_NOTIFICATIONS(state, notifications) {
        state.notifications = notifications
    },
    SET_LOADING(state, status) {
        state.loading = status
    }
}

const actions = {
    async fetchNotifications({ commit }, extra = {}) {
        commit('SET_LOADING', true)
        try {
            const response = await getNotification({
                skipApiCache: true,
                forceRefresh: true,
                ...(extra && typeof extra === 'object' ? extra : {}),
            })
            const list = Array.isArray(response?.data) ? response.data : []
            commit('SET_NOTIFICATIONS', list)
            return list
        } catch (error) {
            console.error('获取通知失败:', error)
            commit('SET_NOTIFICATIONS', [])
            return []
        } finally {
            commit('SET_LOADING', false)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}